import { APPROVAL_WORKFLOW_QUERY } from '@services/permissions'

import type { Section } from '../types'

export const approvalSettingsGroupSection: Section = {
  label: 'layout:page.approvalSettings.group.title',
  route: '/settings/approval-settings/groups',
  permissions: APPROVAL_WORKFLOW_QUERY,
  segment: {
    page: 'Approval Settings - Group',
  },
}

export const approvalSettingsGroupCreateSection: Section = {
  label: 'layout:page.approvalSettings.group.create.title',
  route: '/settings/approval-settings/group/create',
  permissions: APPROVAL_WORKFLOW_QUERY,
  segment: {
    page: 'Approval Settings - Create New Group',
  },
}

export const approvalSettingsGroupUpdateSection: Section = {
  label: 'layout:page.approvalSettings.group.update.title',
  route: '/settings/approval-settings/group/[id]',
  permissions: APPROVAL_WORKFLOW_QUERY,
  segment: {
    page: 'Approval Settings - Edit Group',
  },
}

export const approvalSettingsAccountOperationsSection: Section = {
  label: 'layout:page.approvalSettings.title',
  route: '/settings/approval-settings/account-operations',
  tabLabel: 'layout:page.approvalSettings.accountOperations.title',
  permissions: APPROVAL_WORKFLOW_QUERY,
  segment: {
    page: 'Approval Settings - Account Operations',
  },
}

export const approvalSettingsSection: Section = {
  label: 'layout:page.approvalSettings.title',
  route: '/settings/approval-settings',
  permissions: APPROVAL_WORKFLOW_QUERY,
  segment: {
    page: 'Approval Settings',
  },
  pages: [
    approvalSettingsAccountOperationsSection,
    approvalSettingsGroupCreateSection,
    approvalSettingsGroupUpdateSection,
    approvalSettingsGroupSection,
  ],
}
